import { Translation } from '@ps/web-shared-components';
import React from 'react';

import FormattedTimeZone from '@swf/components/FormattedTimeZone/FormattedTimeZone';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../../../../../types/Cashier';
import { Messages, getBonusMessage } from '../../../../../../../../../utils/bonus';
import DefaultDepositsInfo from '../DefaultDepositsInfo/DefaultDepositsInfo';
import LastEligibleDeposits from '../LastEligibleDeposits/LastEligibleDeposits';

interface Props {
  isSingleTicket: boolean;
}

const EligibleDepositsLeft: React.FC<Props> = ({ isSingleTicket }) => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const { bonusEnd, maxNumberOfDepositsLeft, lastAllowedDepositTime, maxNumTickets } =
    preCashinInfo as PreCashinInfo;

  const lastEligibleDepositTime = (
    <FormattedTimeZone
      date={lastAllowedDepositTime || bonusEnd}
      month="short"
      day="2-digit"
      year="numeric"
      hour="numeric"
      minute="numeric"
      timeZoneName="short"
      hour12={false}
    />
  );

  const isLastPotentialTicketReward: boolean = maxNumTickets === 1;

  if (maxNumberOfDepositsLeft === -1) {
    return (
      <Translation
        tagName="p"
        {...getBonusMessage(
          !lastAllowedDepositTime ? Messages.EligibleDeposits : Messages.LastEligibleDeposits,
          isSingleTicket,
          isLastPotentialTicketReward
        )}
        values={
          !lastAllowedDepositTime
            ? { 0: maxNumTickets }
            : {
                0: isLastPotentialTicketReward ? lastEligibleDepositTime : maxNumTickets,
                1: lastEligibleDepositTime
              }
        }
      />
    );
  }

  return maxNumberOfDepositsLeft === 1 ? (
    <LastEligibleDeposits
      isSingleTicket={isSingleTicket}
      isLastPotentialTicketReward={isLastPotentialTicketReward}
      lastEligibleDepositTime={lastEligibleDepositTime}
    />
  ) : (
    <DefaultDepositsInfo
      isSingleTicket={isSingleTicket}
      isLastPotentialTicketReward={isLastPotentialTicketReward}
      lastEligibleDepositTime={lastEligibleDepositTime}
    />
  );
};

export default EligibleDepositsLeft;
